import React from 'react';
import { Draggable, DraggableProvided } from 'react-beautiful-dnd';
import styled from 'styled-components/macro';
import { shadow5 } from '../styling/shadows';

type Props = {
  draggableId: string;
  index: number;
  children: (dragHandleProps: DraggableProvided['dragHandleProps']) => React.ReactNode;
  className?: string;
};

export const DraggableContainer = ({ draggableId, index, children, className }: Props) => {
  return (
    <Draggable draggableId={draggableId} index={index}>
      {(provided, snapshot) => {
        return (
          <Container
            {...provided.draggableProps}
            className={className}
            ref={provided.innerRef}
            $isDragging={snapshot.isDragging}
          >
            {children(provided.dragHandleProps)}
          </Container>
        );
      }}
    </Draggable>
  );
};

const Container = styled.div<{ $isDragging: boolean }>`
  box-shadow: ${({ $isDragging }) => ($isDragging ? shadow5 : 'none')};
`;
